import React from "react";
import { Link } from "react-router-dom";
import {
  Building2,
  RefreshCw,
  Search,
  FileText,
  ArrowUpRight,
} from "lucide-react";

import ApplicationHeader from "./ApplicationHeader";

const RegistryPortal = () => {
  const services = [
    {
      title: "Enterprise Registration",
      text: "Start and track Free Zone Enterprise registration requests.",
      icon: Building2,
    },
    {
      title: "Licence Renewal",
      text: "Submit renewal requests and update existing licence records.",
      icon: RefreshCw,
    },
    {
      title: "Corporate Search",
      text: "Request official registry verification and certified extracts.",
      icon: Search,
    },
  ];

  return (
    <>
      <ApplicationHeader />

      <main className="min-h-screen bg-[#f8fafc]">
        <section className="max-w-7xl mx-auto px-6 py-14">
          <div className="bg-white rounded-[32px] p-8 border border-slate-200 shadow-sm mb-10">
            <div className="w-16 h-16 rounded-2xl bg-[#026b07]/10 text-[#026b07] flex items-center justify-center mb-6">
              <FileText size={32} />
            </div>

            <h2 className="text-4xl font-black text-[#082567] mb-3">
              Registry Portal
            </h2>

            <p className="text-slate-600 max-w-2xl leading-7">
              Coming Soon! This dashboard will support enterprise registration,
              licence renewals, corporate record updates, registry verification
              and application tracking.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {services.map((item, index) => {
              const Icon = item.icon;

              return (
                <div
                  key={index}
                  className="bg-white rounded-[28px] p-7 border border-slate-200 hover:border-[#f2af11] hover:-translate-y-1 transition-all"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#f2af11]/15 text-[#082567] flex items-center justify-center mb-5">
                    <Icon size={27} />
                  </div>

                  <h3 className="text-xl font-black text-[#082567] mb-3">
                    {item.title}
                  </h3>

                  <p className="text-slate-600 leading-7 text-sm">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-10 text-[#026b07] font-bold hover:text-[#082567]"
          >
            Back to main website
            <ArrowUpRight size={16} />
          </Link>
        </section>
      </main>
    </>
  );
};

export default RegistryPortal;